import SummaryOverall from 'models/SummaryOverall';
import Base from 'models/Base';
import { toEntityList } from 'models/BaseList';

import {
  SUMMARY_OVERALL_ASYNC_START,
  SUMMARY_OVERALL_ASYNC_FAIL,
  SUMMARY_OVERALL_ASYNC_SUCCESS,
  SUMMARY_OVERALL_SELECT_ALL,
  SUMMARY_OVERALL_DESELECT_ALL,
  SUMMARY_OVERALL_SELECT_LINE,
  SUMMARY_OVERALL_DESELECT_LINE,
} from 'actions/summaryOverall';

const initialState = new Base({
  loading: false,
  errorMessage: '',
  list: toEntityList([], SummaryOverall),
  apiList: toEntityList([], SummaryOverall),
});

const actionsMap = {
  [SUMMARY_OVERALL_ASYNC_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: '',
    });
  },
  [SUMMARY_OVERALL_ASYNC_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      apiList: toEntityList(action.data, SummaryOverall),
    });
  },
  [SUMMARY_OVERALL_ASYNC_FAIL]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.errorMessage,
    });
  },
  [SUMMARY_OVERALL_SELECT_ALL]: (state) => {
    const apiList = state.get('apiList');

    return state.merge({
      loading: false,
      errorMessage: null,
      list: apiList,
      apiList: apiList.map((item) => item.set('Selected', true)),
    });
  },
  [SUMMARY_OVERALL_DESELECT_ALL]: (state) => {
    const apiList = state.get('apiList');

    return state.merge({
      loading: false,
      errorMessage: null,
      list: initialState.get('list'),
      apiList: apiList.map((item) => item.set('Selected', false)),
    });
  },
  [SUMMARY_OVERALL_SELECT_LINE]: (state, action) => {
    const { overallLine } = action;
    const list = state.get('list');
    const apiList = state.get('apiList');

    return state.merge({
      loading: false,
      errorMessage: null,
      list: list.push(overallLine),
      apiList: apiList.map((item) => {
        if (item.get('EPUID') === overallLine.EPUID) {
          return item.set('Selected', true);
        }

        return item;
      }),
    });
  },
  [SUMMARY_OVERALL_DESELECT_LINE]: (state, action) => {
    const { overallLine } = action;
    const list = state.get('list');
    const apiList = state.get('apiList');

    return state.merge({
      loading: false,
      errorMessage: null,
      list: list.filter((line) => line.EPUID !== overallLine.EPUID),
      apiList: apiList.map((item) => {
        if (item.get('EPUID') === overallLine.EPUID) {
          return item.set('Selected', false);
        }

        return item;
      }),
    });
  },
};

export default function summaryOverall(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
